'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import DrawerMenu from '../../pro/components/Widgets/DrawerMenu.react';
import BoardStore from '../../stores/BoardStore';
import { getMealFavoriteUuids } from '../../utils/Meals';

import './PastMenu.scss';

export default class PastMenu extends Component {

    static contextTypes = {
        user: PropTypes.object,
        router: PropTypes.object,
        onFavoriteMeal: PropTypes.func,
        startAddMeal: PropTypes.func,
        startRepeatMeal: PropTypes.func,
        startRescheduleMeal: PropTypes.func,
        showMealDetails: PropTypes.func,
        recipes: PropTypes.object,
        foods: PropTypes.object,
    };

    render() {
        const { user } = this.context;
        const { inhibit_swap = false, rd_override = false } = user || {};
        const { date, mealType, meals, primary, fromDailyLog = false } = this.props;
        const { router, startAddMeal, onFavoriteMeal, startRescheduleMeal, startRepeatMeal, showMealDetails, recipes, foods } = this.context;

        const allowedModes = ['restaurants', 'store', 'favorites', 'browser','use-own-recipe', 'create-custom'];

        // REMOVE shows when any dish of the meal is on a board, as onFavoriteMeal decides
        const isBoarded = getMealFavoriteUuids(meals || [], recipes, foods)
            .some(resourceUuid => BoardStore.getBoardsByResourceId(resourceUuid).length > 0);

        return (
            <DrawerMenu key="past-ellipsis" menuTitle="More Options" button={<i className="icon-ellipsis2" />}
                className="ellipsis-menu-btn" modalClassName="feed-past-menu">
                <div className="feed-menu-content">
                    {!fromDailyLog && (
                        <button className="menu-item add-food" onClick={() => startAddMeal(date, mealType, {defaultMode: 'browser', allowedModes, auto_log: true})}>
                            Add more food <i className="icon-add-circle-outline2" />
                        </button>
                    )}
                    {primary.meal_type !== 'leftover' && (!inhibit_swap || rd_override) ?
                        <button className="menu-item reschedule" onClick={() => startRepeatMeal(meals)}>
                            Repeat meal <i className="icon-calendar7" />
                        </button>
                    : null}
                    {(!inhibit_swap || rd_override) ?
                        <button className="menu-item reschedule" onClick={() => startRescheduleMeal(meals)}>
                            Reschedule <i className="icon-calendar7" />
                        </button>
                    : null}
                    {!fromDailyLog && (
                        <button className="menu-item view-details" onClick={() => router.push(`/log/${date.format('YYYY-MM-DD')}`)}>
                            View daily log <i className="icon-pencil-notebook" />
                        </button>
                    )}
                    {primary.meal_type !== 'product' ? <button className="menu-item favorites" onClick={() => onFavoriteMeal(primary)}>
                        {isBoarded ? "Remove from favorites" : "Add to favorites"} <i className="icon-heart2" />
                    </button> : null}
                    {fromDailyLog && showMealDetails && (
                        <button className="menu-item view-details" onClick={() => {
                            showMealDetails(meals);
                        }}>
                            View Meal Details <i className="icon-info" />
                        </button>
                    )}
                </div>
            </DrawerMenu>
        );
    }
}
